import request from '../servises/request'
import microRequest from "@/servises/microRequest";

export function login(email, password, remember) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {
      email,
      password,
      remember
    }
  })
}

export function microLogin(email, password, remember) {
  return microRequest({
    url: 'api/auth/login',
    method: 'post',
    data: {
      email,
      password,
      remember
    }
  })
}

export function getInfo() {
  return request({
    url: `/auth/me`,
    method: 'post'
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

export function refreshMicroToken() {
  return microRequest({
    url: 'api/auth/refresh',
    method: 'post'
  })
}

export function changePassword(user_id, data) {
  return request({
    url: `/user/${user_id}/password`,
    method: 'put',
    data: data
  })
}
